function ConditionListController() {
  const ctrl = this;
  ctrl.$onInit = () => {
  };
}
angular
  .module('pis-tool.module')
  .controller('ConditionListController', ConditionListController);
